export const theme = {
    colors: {/* Название переменным даём таким образом чтобы их можно было переименовать(переназначить) */
        primaryBg: "#937899",
        secondaryBg: "#634e68",
        accent: "#7572D5",/* ставим заяптую потому что это объект а не точка с запятой */
        
        font: "#FFFFFF",

        borderColor: "#4A4A4A",
        placeholderColor: "#495057"
    },

    media: {
        tablet: "screen and (max-width: 768px)",
        mobile: "screen and (max-width: 576px)",
        desktop: "screen and (min-width: 1140px)",

    },

    animations: {
        transition: "0.2s ease-in-out"
    }
}